function initDeluxeSeatsLanding() {
  const section = document.querySelector('.deluxe-seats-landing');
  if (!section) return;

  const toggles = section.querySelectorAll('.ds-cta--toggle');

  toggles.forEach((toggle) => {
    // Avoid double-binding if the section re-inits (e.g. theme editor)
    if (toggle.dataset.dsBound === 'true') return;
    toggle.dataset.dsBound = 'true';

    toggle.addEventListener('click', () => {
      const targetId = toggle.getAttribute('aria-controls');
      const grid = targetId ? document.getElementById(targetId) : null;
      if (!grid) return;

      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isExpanded));

      if (isExpanded) {
        grid.setAttribute('hidden', '');
      } else {
        grid.removeAttribute('hidden');
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initDeluxeSeatsLanding);
document.addEventListener('shopify:section:load', initDeluxeSeatsLanding);
